import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = { class: "buttons-wrapper mt-3 mb-3" }

import { ref } from "vue";
import NumberInput from "../common/NumberInput.vue";
import Constants from '@/guiide/ts/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'YearEditor',
  emits: {
    'updateYear': null,
    'cancelled': null
},
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const niIncome = ref(null);
const income = ref(0);

function initialize() {
    niIncome.value.takeFocus();
}

function setIncome(annualIncome: number) {
    income.value = annualIncome;
}

__expose({ initialize, setIncome });

function onUpdateClicked() {
    if (!niIncome.value.isValid()) {
        return;
    }

    emit('updateYear', income.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NumberInput, {
        ref_key: "niIncome",
        ref: niIncome,
        modelValue: income.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((income).value = $event)),
        description: "Income",
        optional: false,
        min: _unref(Constants).MinAnnualIncome,
        max: _unref(Constants).MaxAnnualIncome,
        onEntered: onUpdateClicked
      }, null, 8, ["modelValue", "min", "max"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary float-end ms-2",
        onClick: onUpdateClicked
      }, "Update"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary float-end",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancelled')))
      }, "Cancel")
    ])
  ]))
}
}

})